import { classNames } from '@dimjs/utils';
import { FC } from 'react';
import { Modal, ModalProps } from '../modal';
import './style.less';

export type ModalFullProps = ModalProps;

export const ModalFull: FC<ModalFullProps> = (props) => {
  return (
    <Modal {...props} className={classNames('v-modal-full', props.className)}>
      {props.children}
    </Modal>
  );
};
